"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ChartDimensionState_1 = require("../../entity/ChartDimensionState");
var DimensionValueState_1 = require("../../entity/DimensionValueState");
var core_1 = require("@material-ui/core");
var styled_components_1 = require("styled-components");
var dimensionArrayEquals_1 = require("../../utility/dimensionArrayEquals");
var useMounted_1 = require("../../hooks/useMounted");
var RequestVariables_1 = require("../../entity/RequestVariables");
var convertDimensionStateToRequest_1 = require("../../utility/convertDimensionStateToRequest");
var useStyles = (0, core_1.makeStyles)(function () {
    return (0, core_1.createStyles)({
        select: {
            height: '40px',
            minWidth: '120px',
            minHeight: '35px',
            borderColor: '#E6E7E8',
            '& .MuiOutlinedInput-input': {
                padding: '8px 32px 8px 12px'
            }
        },
        selectLabel: {
            color: '#4C566C',
            fontSize: '12px',
            marginBottom: '4px'
        },
        formControl: {
            minWidth: 80,
            maxWidth: 280
        },
        chips: {
            display: 'flex',
            overflow: 'scroll'
        },
        chip: {
            height: '18px',
            margin: 2
        }
    });
});
var BreakdownSelectorForHooks = function (_a) {
    var chartData = _a.chartData, identifier = _a.identifier, scope = _a.scope, chartDimensionKeyState = _a.chartDimensionKeyState, dispatchChartDimensionKeyState = _a.dispatchChartDimensionKeyState, previousChartDimensionKeyState = _a.previousChartDimensionKeyState, setPreviousChartDimensionKeyState = _a.setPreviousChartDimensionKeyState, datasetsValue = _a.datasetsValue, refetch = _a.refetch, isDataplatform = _a.isDataplatform;
    var classes = useStyles();
    var _b = (0, react_1.useState)(true), isInit = _b[0], setIsInit = _b[1];
    var isMounted = (0, useMounted_1["default"])();
    (0, react_1.useEffect)(function () {
        if (refetch && datasetsValue === 'all' && isMounted) {
            handleChangeRadioToAll();
            refetch(RequestVariables_1["default"].fromJSON(__assign(__assign({}, identifier), { scope: scope, breakdowns: [] })));
        }
    }, [datasetsValue]);
    var onCloseSelector = function () {
        if (refetch && !(0, dimensionArrayEquals_1["default"])(chartDimensionKeyState, previousChartDimensionKeyState)) {
            refetch(RequestVariables_1["default"].fromJSON(__assign(__assign({}, identifier), { scope: scope, breakdowns: (0, convertDimensionStateToRequest_1["default"])(chartDimensionKeyState) })));
        }
        setPreviousChartDimensionKeyState(chartDimensionKeyState);
    };
    var onClickAllSelection = function (dimensionIndex, isSelectedAll) {
        if (chartDimensionKeyState) {
            dispatchChartDimensionKeyState.setDimensionKeyState({
                type: 'ALL_SELECT',
                dimensionIndex: dimensionIndex,
                isSelectedAll: isSelectedAll
            });
        }
    };
    var handleBreakdownClearButtonClick = function (dimensionIndex) {
        if (chartDimensionKeyState) {
            dispatchChartDimensionKeyState.setDimensionKeyState({
                type: 'CLEAR',
                dimensionIndex: dimensionIndex
            });
        }
    };
    var handleChartFilterClick = function (dimensionIndex, filterIndex) {
        if (chartDimensionKeyState) {
            dispatchChartDimensionKeyState.setDimensionKeyState({
                type: 'FILTER',
                dimensionIndex: dimensionIndex,
                filterIndex: filterIndex
            });
        }
    };
    var handleChangeRadioToAll = function () {
        if (chartDimensionKeyState) {
            dispatchChartDimensionKeyState.setDimensionKeyState({
                type: 'ALL_INIT'
            });
        }
    };
    var handleChangeBreakdownRadio = function (dimensionIndex, filterIndex) {
        if (chartDimensionKeyState) {
            dispatchChartDimensionKeyState.setDimensionKeyState({
                type: 'ALL',
                dimensionIndex: dimensionIndex,
                filterIndex: filterIndex
            });
        }
    };
    var chartBreakdowns = chartData
        ? Array.isArray(chartData)
            ? chartData[0].breakdowns
                ? chartData[0].breakdowns
                : undefined
            : chartData.breakdowns
                ? chartData.breakdowns
                : undefined
        : undefined;
    (0, react_1.useEffect)(function () {
        if (chartBreakdowns && isInit) {
            var initialChartDimensionState = isDataplatform
                ? chartBreakdowns.map(function (breakdown) {
                    var filterState = breakdown.values
                        ? breakdown.values.map(function (filter) {
                            return new DimensionValueState_1["default"]({ value: filter, isSelected: false });
                        })
                        : [];
                    return new ChartDimensionState_1["default"]({
                        breakdown: new DimensionValueState_1["default"]({ value: breakdown.key.label, isSelected: false }),
                        filter: filterState
                    });
                })
                : chartBreakdowns
                    .filter(function (breakdown) { return breakdown.display; })
                    .map(function (breakdown) {
                    var filterState = breakdown.values
                        ? breakdown.values.map(function (filter) {
                            return new DimensionValueState_1["default"]({ value: filter, isSelected: false });
                        })
                        : [];
                    return new ChartDimensionState_1["default"]({
                        breakdown: new DimensionValueState_1["default"]({ value: breakdown.key.label, isSelected: false }),
                        filter: filterState
                    });
                });
            dispatchChartDimensionKeyState.setDimensionKeyState({
                type: 'INIT',
                initState: initialChartDimensionState
            });
            setIsInit(false);
        }
    });
    var ITEM_HEIGHT = 48;
    var ITEM_PADDING_TOP = 8;
    var MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250
            }
        }
    };
    // TODO
    // If Chart.header.breakdowns is not empty, BreakdownSelector should display the default breakdown filter.
    return ((0, jsx_runtime_1.jsx)(BreakdownContainer, { children: chartDimensionKeyState.length > 0
            ? chartDimensionKeyState.map(function (dimensionKeyState, dimensionIndex) {
                return ((0, jsx_runtime_1.jsxs)(Breakdowns, { children: [(0, jsx_runtime_1.jsx)(core_1.Typography, __assign({ className: classes.selectLabel }, { children: dimensionKeyState.breakdown.value })), (0, jsx_runtime_1.jsx)(core_1.FormControl, __assign({ className: classes.formControl }, { children: (0, jsx_runtime_1.jsxs)(core_1.Select, __assign({ className: classes.select, variant: "outlined", value: new Array(dimensionKeyState.breakdown.value), renderValue: function () { return ((0, jsx_runtime_1.jsx)("div", __assign({ className: classes.chips }, { children: dimensionKeyState.filter
                                        .filter(function (item) { return item.isSelected; })
                                        .map(function (item) { return ((0, jsx_runtime_1.jsx)(core_1.Chip, { label: item.value, className: classes.chip }, item.value)); }) }))); }, multiple: true, MenuProps: MenuProps, onClose: onCloseSelector }, { children: [datasetsValue !== 'all' ? ((0, jsx_runtime_1.jsxs)(core_1.MenuItem, __assign({ onClick: function () {
                                            return onClickAllSelection(dimensionIndex, !dimensionKeyState.filter.some(function (filter) { return !filter.isSelected; }));
                                        } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Checkbox, { color: "primary", 
                                                // onChange={(event) => onClickAllSelection(dimensionIndex, !event.target.checked)}
                                                checked: !dimensionKeyState.filter.some(function (filter) { return !filter.isSelected; }) }), (0, jsx_runtime_1.jsx)(core_1.ListItemText, { primary: "\u5168\u9078\u629E" })] }))) : ((0, jsx_runtime_1.jsxs)(core_1.MenuItem, __assign({ onClick: function () { return handleBreakdownClearButtonClick(dimensionIndex); } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Radio, { checked: !dimensionKeyState.filter.some(function (filter) { return filter.isSelected; }), color: "primary" }), (0, jsx_runtime_1.jsx)(core_1.ListItemText, { primary: "\u672A\u9078\u629E" })] }))), dimensionKeyState.filter
                                        ? dimensionKeyState.filter.map(function (filter, filterIndex) {
                                            return datasetsValue == 'all' ? ((0, jsx_runtime_1.jsxs)(core_1.MenuItem, __assign({ value: filter.value, onClick: function () { return handleChangeBreakdownRadio(dimensionIndex, filterIndex); } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Radio, { checked: filter.isSelected, color: "primary" }), (0, jsx_runtime_1.jsx)(core_1.ListItemText, { primary: filter.value })] }), filter.value)) : ((0, jsx_runtime_1.jsxs)(core_1.MenuItem, __assign({ value: filter.value, onClick: function () { return handleChartFilterClick(dimensionIndex, filterIndex); } }, { children: [(0, jsx_runtime_1.jsx)(core_1.Checkbox, { checked: filter.isSelected, 
                                                        // onClick={() => handleChartFilterClick(dimensionIndex, filterIndex)}
                                                        color: "primary" }), (0, jsx_runtime_1.jsx)(core_1.ListItemText, { primary: filter.value })] }), filter.value));
                                        })
                                        : null] })) }))] }, dimensionKeyState.breakdown.value));
            })
            : null }));
};
var BreakdownContainer = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Breakdowns = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  margin: 8px;\n"], ["\n  margin: 8px;\n"])));
exports["default"] = BreakdownSelectorForHooks;
var templateObject_1, templateObject_2;
